import axios from "axios";

const URL_AGENTE_CLISITEF = "https://127.0.0.1/agente/clisitef";

const api = axios.create({
  baseURL: URL_AGENTE_CLISITEF,
});

function getMessageErrorClisitefStatus(codigo) {
  const mensagens = {
    0: "Sucesso na execução da função.",
    10000: "Deve ser chamada a rotina de continuidade do processo.",
    outro_valor_positivo: "Negada pelo autorizador.",
    "-1":
      "Módulo não inicializado. O PDV tentou chamar alguma rotina sem antes executar a função configuração.",
    "-2": "Operação cancelada pelo operador.",
    "-3": "O parâmetro função / modalidade é inexistente/inválido.",
    "-4": "Falta de memória no PDV.",
    "-5": "Sem comunicação com o SiTef.",
    "-6": "Operação cancelada pelo usuário (no pinpad).",
    "-7": "Reservado",
    "-8":
      "A CliSiTef não possui a implementação da função necessária, provavelmente está desatualizada (a CliSiTef é mais recente).",
    "-9":
      "A automação chamou a rotina ContinuaFuncaoSiTefInterativo sem antes iniciar uma função iterativa.",
    "-10":
      "Algum parâmetro obrigatório não foi passado pela automação comercial.",
    "-12":
      "Erro na execução da rotina iterativa. Provavelmente o processo iterativo anterior não foi executado até o final (enquanto o retorno foi igual a 10000).",
    "-13":
      "Documento fiscal não encontrado nos registros da CliSiTef. Retornado em funções de consulta tais como ObtemQuantidadeTransacoesPendentes.",
    "-14": "Operação cancelada pela automação comercial.",
    "-15": "Parâmetro inválido passado para a função.",
    "-20":
      "Utilizada uma palavra proibida, por exemplo SENHA, para coletar dados em aberto no pinpad. Por exemplo na função ObtemDadoPinpadDiretoEx.",
    "-21": "Erro no Correspondente Bancário: Deve realizar sangria.",
    "-30":
      "Erro de acesso ao arquivo. Certifique-se que o arquivo que roda a aplicação tem direitos de leitura/escrita.",
    "-31": "Transação negada pelo servidor SiTef.",
    "-32": "Dados inválidos.",
    "-33": "Reservado",
    "-34": "Problema na execução de alguma das rotinas no pinpad.",
    "-40": "Transação não segura.",
    outro_valor_negativo: "Erros detectados internamente pela rotina.",
  };

  if (mensagens[codigo] !== undefined) {
    return mensagens[codigo];
  } else if (codigo > 0) {
    return mensagens.outro_valor_positivo;
  } else {
    return mensagens.outro_valor_negativo;
  }
}

class TefService {
  sitefIp;
  lojaId;
  terminalId;
  sessaoId;
  cupomFiscal;
  dataFiscal;
  horaFiscal;
  continua;
  cashierOperator;
  trnAdditionalParameters;
  trnInitParameters;

  manipuladores;

  dadosTransacao;

  cont = 0;

  handleTermina;

  hasCallFinishTransaction;

  executando;

  confirmaDeterminado = undefined;

  trnAdditionalParametersSufixo = "";

  cancelamentoSolicitado;
  requisicaoContinueEmAndamento;

  constructor(manipuladoresInput, config) {
    this.sitefIp = config.sitefIp;
    this.lojaId = config.lojaId;
    this.terminalId = config.terminalId;

    this.trnAdditionalParameters = "";
    this.trnInitParameters = config.trnInitParameters ? config.trnInitParameters : '';

    this.trnAdditionalParametersSufixo = config.trnAdditionalParametersSufixo;

    this.continua = 0;

    this.cancelamentoSolicitado = false;
    this.requisicaoContinueEmAndamento = false;

    this.dadosTransacao = [];

    this.executando = false;

    this.confirmaDeterminado = undefined;

    this.cashierOperator = config.cashierOperator;

    const manipuladores = { ...manipuladoresInput };

    if (!manipuladores.mensagemVisorOperador) {
      manipuladores.mensagemVisorOperador = () => {};
    }

    if (!manipuladores.mensagemVisorCliente) {
      manipuladores.mensagemVisorCliente = () => {};
    }

    if (!manipuladores.mensagemDoisVisores) {
      manipuladores.mensagemDoisVisores = () => {};
    }

    if (!manipuladores.textoTituloApresentacaoMenu) {
      manipuladores.textoTituloApresentacaoMenu = () => {};
    }

    if (!manipuladores.removerMensagemVisorOperador) {
      manipuladores.removerMensagemVisorOperador = () => {};
    }

    if (!manipuladores.removerMensagemVisorCliente) {
      manipuladores.removerMensagemVisorCliente = () => {};
    }

    if (!manipuladores.removerMensagemDoisVisores) {
      manipuladores.removerMensagemDoisVisores = () => {};
    }

    if (!manipuladores.removerTituloApresentacaoMenu) {
      manipuladores.removerTituloApresentacaoMenu = () => {};
    }

    if (!manipuladores.apresentarCabecalhoInformacoesAdicionais) {
      manipuladores.apresentarCabecalhoInformacoesAdicionais = () => {};
    }

    if (!manipuladores.removerCabecalhoInformacoesAdicionais) {
      manipuladores.removerCabecalhoInformacoesAdicionais = () => {};
    }

    if (!manipuladores.apresentarTextoEObterRespostaSimOuNao) {
      manipuladores.apresentarTextoEObterRespostaSimOuNao = () => {};
    }

    if (!manipuladores.apresentarMenuOpcoes) {
      manipuladores.apresentarMenuOpcoes = () => {};
    }

    if (!manipuladores.apresentarMensagemOperadorEAguardarTecla) {
      manipuladores.apresentarMensagemOperadorEAguardarTecla = () => {};
    }

    if (!manipuladores.interromperProcessoColetaDados) {
      manipuladores.interromperProcessoColetaDados = () => {};
    }

    if (!manipuladores.lerCampoSemIntervencaoOperador) {
      manipuladores.lerCampoSemIntervencaoOperador = () => {};
    }

    if (!manipuladores.lerCampo) {
      manipuladores.lerCampo = () => {};
    }

    if (!manipuladores.lerNumeroCheque) {
      manipuladores.lerNumeroCheque = () => {};
    }

    if (!manipuladores.lerCampoMonetario) {
      manipuladores.lerCampoMonetario = () => {};
    }

    if (!manipuladores.coletarCodigoBarras) {
      manipuladores.coletarCodigoBarras = () => {};
    }

    if (!manipuladores.lerCampoMacarado) {
      manipuladores.lerCampoMacarado = () => {};
    }

    if (!manipuladores.menuIdentificado) {
      manipuladores.menuIdentificado = () => {};
    }

    if (!manipuladores.limparCorpo) {
      manipuladores.limparCorpo = () => {};
    }

    this.manipuladores = manipuladores;
  }

  setSessionId(sessaoId) {
    this.sessaoId = sessaoId
  }

  getSessionId() {
    return this.sessaoId
  }

  async getState() {
    const response = await api.get("/state");
    return response.data;
  }

  async getSession() {
    const response = await api.get("/session");
    return response.data;
  }

  async getStatePinPad(sessionId) {
    const params = new URLSearchParams({
      sessionId
    });

    const response = await api.post("/pinpad/isPresent", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return response.data;
  }

  async createSession() {
    const params = new URLSearchParams({
      sitefIp: this.sitefIp,
      storeId: this.lojaId,
      terminalId: this.terminalId,
    });

    const response = await api.post("/session", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return response.data;
  }

  async deleteSession() {
    const response = await api.delete("/session");
    return response.data;
  }

  async assertAgenteLivre() {
    const state = await this.getState();

    if (state.serviceStatus !== 0) {
      throw "AgenteCliSiTef indisponível.";
    }

    switch (state.serviceState) {
      case 0:
        throw "AgenteCliSiTef não inicializado.";
        break;
      case 1:
        break;
      case 2: {
        const dados = await this.chamarContinueTransactionCompatibilidade();
        if(!dados.status) throw dados.message
        break;
      }
      case 3: {
        const dados = await this.chamarContinueTransactionCompatibilidade();
        if(!dados.status) throw dados.message
        break;
      }
      case 4:
        break;
      default:
        throw `Estado desconhecido do AgenteCliSiTef: ${state.serviceState}`;
        break;
    }
  }

  async startTransation(functionId, trnAmount, config) {
    try {
      if (this.executando) throw "TEF já está em execução";

      this.executando = true;
      this.cupomFiscal = config.cupomFiscal;
      this.dataFiscal = config.dataFiscal;
      this.horaFiscal = config.horaFiscal;

      this.trnAdditionalParameters = config.trnAdditionalParameters;

      this.handleTermina = config.handleTermina;

      this.hasCallFinishTransaction = config.hasCallFinishTransaction;

      this.continua = 0;

      this.cancelamentoSolicitado = false;
      this.requisicaoContinueEmAndamento = false


      this.dadosTransacao = [];

      this.confirmaDeterminado = config.confirmaDeterminado;

      await this.assertAgenteLivre();

      const url = `/startTransaction`;
      const params = new URLSearchParams({
        sessionId: this.sessaoId,
        functionId: functionId,
        trnAmount: trnAmount,
        taxInvoiceNumber: this.cupomFiscal,
        taxInvoiceDate: this.dataFiscal,
        taxInvoiceTime: this.horaFiscal,
        cashierOperator: this.cashierOperator,
        trnAdditionalParameters: this.trnAdditionalParameters
          ? `${this.trnAdditionalParameters}${this.trnAdditionalParametersSufixo ? `;${this.trnAdditionalParametersSufixo}` : ''}`
          : this.trnAdditionalParametersSufixo,
        trnInitParameters: this.trnInitParameters,
      });

      const response = await api.post(url, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const {
        serviceStatus,
        serviceMessage,
        clisitefStatus,
        sessionId,
      } = response.data;

      if (serviceStatus === 1) {
        throw serviceMessage;
      }

      if (serviceStatus !== 0) {
        throw "StartTransaction: Erro Desconhecido";
      }

      if (clisitefStatus !== 10000) {
        throw "StartTransaction: Não prosseguiu";
      }

      this.continueTransaction("");
    } catch (e) {
      this.executando = false;
      if (e.message === "Network Error") {
        this.handleTermina(false, null, 'Erro Comunicação Agente Clisitef');
      } else if (e.response) {
        this.handleTermina(false, null, e ? e.toString() : "error");
      } else {
        this.handleTermina(false, null, e ? e.toString() : "error");
      }
    }
  }

  async chamarContinueTransactionCompatibilidade() {
    try {
      for(let i = 0; i < 10; i++) {
        const params = new URLSearchParams({
          sessionId: this.sessaoId,
          data: '',
          continue: -1,
        });

        const response = await api.post("/continueTransaction", params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        const {
          serviceStatus,
          serviceMessage,
          clisitefStatus,
          data,
          commandId,
          fieldId,
          fieldMinLength,
          fieldMaxLength,
          sessionId
        } = response.data;

        if (serviceStatus !== 0) {
          throw serviceMessage;
        }

        if (clisitefStatus !== 10000) {
          /* if (clisitefStatus === -2) {
            return {
              status: true,
              message: ''
            }
          }

          if (clisitefStatus === 0) {
            return {
              status: true,
              message: ''
            }
          }
          throw getMessageErrorClisitefStatus(clisitefStatus); */

          return {
            status: true,
            message: ''
          }
        }
      }

      throw 'passou do maximo de iterações'

    } catch(e) {
      return {
        status: false,
        message: e ? e.toString() : 'ERROR'
      }
    }
  }

  async chamarContinueTransaction(dataInput, continuaInput) {
    if (this.requisicaoContinueEmAndamento) {
      if (continuaInput === -1) {
        this.cancelamentoSolicitado = true;
        this.manipuladores.removerQrcodePix();
      }

      return {
        chamadaIgnoradaPorConcorrencia: true,
      };
    }

    this.requisicaoContinueEmAndamento = true;

    try {
      const params = new URLSearchParams({
        sessionId: this.sessaoId,
        data: dataInput,
        continue: continuaInput,
      });

      const response = await api.post("/continueTransaction", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      return response.data;
    } finally {
      this.requisicaoContinueEmAndamento = false;
    }
  }

  async solicitarCancelamentoTransacaoAtual() {
    this.cancelamentoSolicitado = true;
    this.manipuladores.removerQrcodePix();

    if (!this.sessaoId) {
      throw "Não existe sessionId ativo para cancelar a transação.";
    }

    if (this.requisicaoContinueEmAndamento) {
      return {
        solicitado: true,
        aguardandoRequisicaoAtual: true,
      };
    }

    await this.continueTransaction("", null, -1);

    return {
      solicitado: true,
      aguardandoRequisicaoAtual: false,
    };
  }

  async continueTransaction(dataInput, tipoCampoAnterior, continuaInput = this.continua) {
    try {
      const dados = await this.chamarContinueTransaction(dataInput, continuaInput);

      if (!dados || dados.chamadaIgnoradaPorConcorrencia) {
        return;
      }

      const {
        serviceStatus,
        serviceMessage,
        clisitefStatus,
        data,
        commandId,
        fieldId,
        fieldMinLength,
        fieldMaxLength,
        sessionId
      } = dados;

      if (serviceStatus !== 0) {
        throw serviceMessage;
      }

      if (clisitefStatus !== 10000) {
        if (clisitefStatus === 0) {
          if (this.hasCallFinishTransaction) {
            const confirma =
              this.confirmaDeterminado === undefined ||
              this.confirmaDeterminado === null
                ? 1
                : this.confirmaDeterminado;

            this.finishTransaction(
              confirma,
              {
                taxInvoiceNumber: this.cupomFiscal,
                taxInvoiceDate: this.dataFiscal,
                taxInvoiceTime: this.horaFiscal,
                handleTermina: this.handleTermina,
              },
              ""
            );
          } else {
            this.executando = false;
            this.handleTermina(true, this.dadosTransacao, "");
          }
          return;
        }
        throw getMessageErrorClisitefStatus(clisitefStatus);
      }

      if (this.cancelamentoSolicitado) {
        this.cancelamentoSolicitado = false;
        this.manipuladores.removerQrcodePix();

        await this.continueTransaction("", null, -1);
        return;
      }

      this.manipuladores.limparCorpo();

      this.cont = this.cont + 1;

      if (tipoCampoAnterior) {
        if (tipoCampoAnterior === 505) {
          const campo = {
            TipoCampo: "numero_parcelas",
            Valor: dataInput,
          };

          this.dadosTransacao.push(campo);
        }
      }

      switch (commandId) {
        case 0: {
          const campo = {
            TipoCampo: dados.fieldId,
            Valor: dados.data,
          };

          this.dadosTransacao.push(campo);
          this.continueTransaction("");
          break;
        }
        case 1:
          this.manipuladores.mensagemVisorOperador(data);
          this.continueTransaction("");
          break;
        case 2:
          this.manipuladores.mensagemVisorCliente(data);
          this.continueTransaction("");
          break;
        case 3:
          this.manipuladores.mensagemDoisVisores(data);
          this.continueTransaction("");
          break;
        case 4:
          this.manipuladores.textoTituloApresentacaoMenu(data);
          this.continueTransaction("");
          break;
        case 11:
          this.manipuladores.removerMensagemVisorOperador();
          this.continueTransaction("");
          break;
        case 12:
          this.manipuladores.removerMensagemVisorCliente();
          this.continueTransaction("");
          break;
        case 13:
          this.manipuladores.removerMensagemDoisVisores();
          this.continueTransaction("");
          break;
        case 14:
          this.manipuladores.removerTituloApresentacaoMenu();
          this.continueTransaction("");
          break;
        case 15:
          this.manipuladores.apresentarCabecalhoInformacoesAdicionais(data);
          this.continueTransaction("");
          break;
        case 16:
          this.manipuladores.removerCabecalhoInformacoesAdicionais();
          this.continueTransaction("");
          break;
        case 20:
          this.manipuladores.apresentarTextoEObterRespostaSimOuNao(data);
          break;
        case 21:
          this.manipuladores.apresentarMenuOpcoes(data);
          break;
        case 22:
          this.manipuladores.apresentarMensagemOperadorEAguardarTecla(data);
          break;
        case 23:
          this.manipuladores.interromperProcessoColetaDados();
          this.continueTransaction("");
          break;
        case 29:
          this.manipuladores.lerCampoSemIntervencaoOperador();
          this.continueTransaction("");
          break;
        case 30:
          this.manipuladores.lerCampo(
            fieldId,
            fieldMinLength,
            fieldMaxLength,
            data
          );
          break;
        case 31:
          this.manipuladores.lerNumeroCheque();
          break;
        case 34:
          this.manipuladores.lerCampoMonetario(
            fieldId,
            fieldMinLength,
            fieldMaxLength,
            data
          );
          break;
        case 35:
          this.manipuladores.coletarCodigoBarras();
          break;
        case 41:
          this.manipuladores.lerCampoMacarado();
          break;
        case 42:
          this.manipuladores.menuIdentificado();
          break;
        case 50:
          this.manipuladores.exibirQrcodePix(data);
          this.continueTransaction("");
          break;
        case 51:
          this.manipuladores.removerQrcodePix();
          this.continueTransaction("");
          break;
        case 52:
          this.manipuladores.mensagemVisorOperador(data);
          this.continueTransaction("");
          break;
        default: {
          const dados = await this.chamarContinueTransactionCompatibilidade();
          if(!dados.status) throw dados.message
          throw `Comando CliSiTef não tratado: ${commandId}. fieldId=${fieldId}, data=${data}`;
          break;
        }
      }
    } catch (e) {
      this.executando = false;

      const mensagemErro = e ? e.toString() : "error no continue transaction";

      this.handleTermina(false, null, mensagemErro);
    }
  }

  async finishTransaction(confirma, config, trnAdditionalParameters) {
    try {
      const url = `/finishTransaction`;
      const params = new URLSearchParams({
        sessionId: this.sessaoId,
        taxInvoiceNumber: config.taxInvoiceNumber,
        taxInvoiceDate: config.taxInvoiceDate,
        taxInvoiceTime: config.taxInvoiceTime,
        confirm: confirma,
        trnAdditionalParameters: trnAdditionalParameters
          ? `${trnAdditionalParameters}${this.trnAdditionalParametersSufixo ? `;${this.trnAdditionalParametersSufixo}` : ''}`
          : this.trnAdditionalParametersSufixo,
      });

      const response = await api.post(url, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const {
        serviceStatus,
        serviceMessage,
        clisitefStatus
      } = response.data;

      if (serviceStatus !== 0) {
        throw (serviceMessage || "Erro no serviço finishTransaction");
      }

      if (clisitefStatus !== 0) {
        throw `Erro ao finalizar TEF. clisitefStatus=${clisitefStatus}`;
      }

      this.executando = false;
      config.handleTermina(true, this.dadosTransacao, "");
    } catch (e) {
      this.executando = false;
      config.handleTermina(false, null, e ? e.toString() : "error");
    }
  }

  setManipuladores(manipuladoresInput) {
    const manipuladores = { ...manipuladoresInput };

    if (!manipuladores.mensagemVisorOperador) {
      manipuladores.mensagemVisorOperador = () => {};
    }

    if (!manipuladores.mensagemVisorCliente) {
      manipuladores.mensagemVisorCliente = () => {};
    }

    if (!manipuladores.mensagemDoisVisores) {
      manipuladores.mensagemDoisVisores = () => {};
    }

    if (!manipuladores.textoTituloApresentacaoMenu) {
      manipuladores.textoTituloApresentacaoMenu = () => {};
    }

    if (!manipuladores.removerMensagemVisorOperador) {
      manipuladores.removerMensagemVisorOperador = () => {};
    }

    if (!manipuladores.removerMensagemVisorCliente) {
      manipuladores.removerMensagemVisorCliente = () => {};
    }

    if (!manipuladores.removerMensagemDoisVisores) {
      manipuladores.removerMensagemDoisVisores = () => {};
    }

    if (!manipuladores.removerTituloApresentacaoMenu) {
      manipuladores.removerTituloApresentacaoMenu = () => {};
    }

    if (!manipuladores.apresentarCabecalhoInformacoesAdicionais) {
      manipuladores.apresentarCabecalhoInformacoesAdicionais = () => {};
    }

    if (!manipuladores.removerCabecalhoInformacoesAdicionais) {
      manipuladores.removerCabecalhoInformacoesAdicionais = () => {};
    }

    if (!manipuladores.apresentarTextoEObterRespostaSimOuNao) {
      manipuladores.apresentarTextoEObterRespostaSimOuNao = () => {};
    }

    if (!manipuladores.apresentarMenuOpcoes) {
      manipuladores.apresentarMenuOpcoes = () => {};
    }

    if (!manipuladores.apresentarMensagemOperadorEAguardarTecla) {
      manipuladores.apresentarMensagemOperadorEAguardarTecla = () => {};
    }

    if (!manipuladores.interromperProcessoColetaDados) {
      manipuladores.interromperProcessoColetaDados = () => {};
    }

    if (!manipuladores.lerCampoSemIntervencaoOperador) {
      manipuladores.lerCampoSemIntervencaoOperador = () => {};
    }

    if (!manipuladores.lerCampo) {
      manipuladores.lerCampo = () => {};
    }

    if (!manipuladores.lerNumeroCheque) {
      manipuladores.lerNumeroCheque = () => {};
    }

    if (!manipuladores.lerCampoMonetario) {
      manipuladores.lerCampoMonetario = () => {};
    }

    if (!manipuladores.coletarCodigoBarras) {
      manipuladores.coletarCodigoBarras = () => {};
    }

    if (!manipuladores.lerCampoMacarado) {
      manipuladores.lerCampoMacarado = () => {};
    }

    if (!manipuladores.menuIdentificado) {
      manipuladores.menuIdentificado = () => {};
    }

    if (!manipuladores.limparCorpo) {
      manipuladores.limparCorpo = () => {};
    }

    this.manipuladores = manipuladores;
  }
}

export default TefService;
